import React from 'react'
import { Box } from '@mui/material'
import FillForm from '../components/fillForm'
import CloseRequestWarning from '../components/closeRequestWarning'
import AdxButton from 'components/custom/AdxButton'

const SubmitDocumentView = ({ item, formikProps, mutation }) => {
  const { values, setFieldValue, handleSubmit, errors } = formikProps

  return (
    <Box
      sx={{
        minHeight: 'calc(70vh - 112px)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        p: 2,
      }}
    >
      <>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            rowGap: 1,
          }}
        >
          {/* Fill Credit Leave Form*/}

          <FillForm item={item} values={values} setFieldValue={setFieldValue} errors={errors} />
        </Box>
        {/* Button part */}
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: 5,
            mb: 1,
          }}
        >
          <CloseRequestWarning button={true} />
          <AdxButton
            variant={'contained'}
            onClick={handleSubmit}
            sx={{ width: 2 / 3 }}
            disabled={mutation.isLoading}
            isLoading={mutation.isLoading}
          >
            Request
          </AdxButton>
        </Box>
      </>
    </Box>
  )
}

export default SubmitDocumentView
